// GAVION open-pixel: Settings → Email (admins).
export const emailSettingsEn = {
  title: "Email",
  open_tracking: "Open tracking",
  open_tracking_help:
    "Adds an invisible pixel to sequence and one-to-one emails sent from Outlook so you know when the lead opens them (never to demo confirmations). A line at the bottom of the email says so. No IP address is kept; probably automatic opens (Apple Mail, security scanners) are flagged.",
  open_tracking_caveat:
    "Note: your own reads of the sent email (Outlook Sent Items) and copies quoted in a reply or forward can also count as opens.",
  save: "Save",
  saved: "Email settings saved.",
};
